import type { MouseEvent, ReactNode } from "react";
import { useLocation, useNavigate } from "react-router";

/** Keep this lookup's opaque history key when following an in-page link. */
export function PropertyCheckNavigation({ children }: { children: ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();

  function followFragment(event: MouseEvent<HTMLDivElement>) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest("a");
    const href = anchor?.getAttribute("href");
    if (!anchor || !href?.startsWith("#") || anchor.hasAttribute("download") || (anchor.target && anchor.target !== "_self")) return;

    // A native fragment navigation creates an entry with null state. The
    // private /check route then correctly refuses to guess which lookup to use.
    event.preventDefault();
    void navigate({ pathname: location.pathname, search: location.search, hash: href }, {
      state: location.state,
      preventScrollReset: true,
    });
    let targetId = href.slice(1);
    try { targetId = decodeURIComponent(targetId); } catch { /* Keep a literal fragment if it is not URI-encoded. */ }
    document.getElementById(targetId)?.scrollIntoView({ block: "start" });
  }

  return <div data-private-property-check className="ph-no-capture" onClick={followFragment}>{children}</div>;
}
